import React, { useEffect, useState } from "react";

//compo
import history from "../../../core/helper/Helper";
import { SearchDialog } from "../../Dialog";

//ui
import SearchIcon from "@material-ui/icons/Search";
import ShoppingCartIcon from "@material-ui/icons/ShoppingCart";
import IconButton from "@material-ui/core/IconButton";
import Tooltip from "@material-ui/core/Tooltip";
import { Badge } from "@material-ui/core";
import { useDispatch, useSelector } from "react-redux";
import { fetchListCartInLocalStorageSuccess } from "redux/ActionCreators/CartActionCreators";

const MenuIconItem = () => {
  const [openSearch, setOpenSearch] = useState(false);
  const dispatch = useDispatch();

  useEffect(() => {
    dispatch(fetchListCartInLocalStorageSuccess());
  }, []);

  const carts = useSelector((state) => {
    return state.carts.listInLocalStorage;
  });

  const handleShoppingCart = () => {
    history.push("/payment/cart");
  };

  const handleSearchIcon = () => {
    setOpenSearch(true);
  };

  const handleCloseSearchDialog = () => {
    setOpenSearch(false);
  };
  return (
    <section>
      <SearchDialog open={openSearch} onClose={handleCloseSearchDialog} />

      <Tooltip title="Tìm kiếm trên kunlez" placement="bottom">
        <IconButton aria-label="delete" onClick={handleSearchIcon}>
          <SearchIcon />
        </IconButton>
      </Tooltip>

      <Tooltip title="Xem giỏ hàng" placement="bottom">
        <IconButton aria-label="delete" onClick={handleShoppingCart}>
          {carts ? (
            <Badge badgeContent={carts.length} color="secondary">
              <ShoppingCartIcon />
            </Badge>
          ) : (
            <ShoppingCartIcon />
          )}
        </IconButton>
      </Tooltip>
    </section>
  );
};

export default MenuIconItem;
